import { useEffect } from "react";
import { useState } from "react";
import { fetchHealthTrends } from "../data/healthTrends";
import AllGraphs from "./graphs/AllGraphs";
import SingleGraph from "./graphs/singleGraph";
import "../styles/HealthView.css";

export default function HealthView({ patient, graphMode = "all" }) {
  const [trends,       setTrends]       = useState(null);
  const [loading,      setLoading]      = useState(false);
  const [error,        setError]        = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    if (!patient?.owner_id) return;

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);
      setTrends(null);
      try {
        const data = await fetchHealthTrends(patient.owner_id, selectedDate);
        if (!cancelled) setTrends(data);
      } catch (err) {
        console.error("HealthView fetch error:", err);
        if (!cancelled) setError("Failed to load health data.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [patient?.owner_id, selectedDate]);

  if (!patient?.owner_id) {
    return <div className="cc-health-empty">No patient selected.</div>;
  }

  return (
    <div className="cc-health-root">

      {loading && (
        <div className="cc-health-loading">
          <div className="cc-spinner" />
          <span>Loading health data…</span>
        </div>
      )}

      {error && (
        <div className="cc-health-error">{error}</div>
      )}

      {!loading && !error && trends && (
        <div className="cc-health-graph-wrap">
          {graphMode === "single" ? (
            <SingleGraph
              trends={trends}
              selectedDate={selectedDate}
              onDateChange={setSelectedDate}
            />
          ) : (
            <AllGraphs
              trends={trends}
              selectedDate={selectedDate}
              onDateChange={setSelectedDate}
            />
          )}
        </div>
      )}

      {!loading && !error && !trends && (
        <div className="cc-health-empty">No health data available for this patient.</div>
      )}

    </div>
  );
}